type CompostionPlanProps = {
  showTitle?: boolean;
  gbPadrao?: number;
  gbPromocional?: number;
  gbBonusPortabilidade?: number;
  gbBonusDedicado?: number;
  mostrarPortabilidade?: boolean;
  mostrarDedicado?: boolean;
  isPos?: boolean;
};

export const CompositionPlan: React.FC<CompostionPlanProps> = ({
  showTitle = true,
  gbPadrao,
  gbPromocional,
  gbBonusPortabilidade,
  gbBonusDedicado,
  mostrarPortabilidade,
  mostrarDedicado,
}) => {
  return (
    <div className="w-full border-t border-gray-100 pt-4 pb-2">
      {showTitle && (
        <span className="text-xs font-medium uppercase tracking-wider text-gray-400">Composição do plano</span>
      )}
      <div className="mt-1.5 flex flex-col justify-center space-y-0.5 text-sm text-gray-700">
        {gbPadrao ? (
          <span>
            <strong className="font-bold">{gbPadrao}GB</strong> do Plano
          </span>
        ) : null}

        {mostrarDedicado && gbBonusDedicado ? (
          <span>
            <strong className="font-bold">{gbBonusDedicado}GB</strong> de Bônus
            Exclusivos para Redes Sociais
          </span>
        ) : null}
        {mostrarPortabilidade && gbBonusPortabilidade ? (
          <span>
            <strong className="font-bold">{gbBonusPortabilidade}GB</strong>{" "}
            Bônus Especial
          </span>
        ) : null}
        {gbPromocional ? (
          <span>
            <strong className="font-bold">{gbPromocional}GB</strong> de Bônus
            Promo de Internet
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default CompositionPlan;
